// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import toast from 'react-hot-toast';
import { useDeleteParkingTypeMutation, useGetParkingTypeDataMutation } from '../../store/api/parkingTypeApi';
import { getparkingType, getParkingTypeTotalRecords, setParkingType } from '../../store/state/parkingTypeSlice';
import { PERMISSION } from '../../utils/userPermission';
import { checkPermissions } from '../../sections/@dashboard/parkingspaces/utility';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'imageUrl', alignRight: false },
  { id: 'serviceType', label: 'Service Categories', alignRight: false },
  { id: 'discountOffer', label: 'Offered Discount', alignRight: false },
  { id: 'serviceTypesStatus', label: 'Service Status', alignRight: false },
];

export default function ServiceType() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const [parkingManagementData, setParkingManagementData] = useState([]);
  const [getParkingTypeData, parkingTypeResponse] = useGetParkingTypeDataMutation();
  const parkingTypeData = useAppSelector(getparkingType);
  const parkingTypeTotalRecord = useAppSelector(getParkingTypeTotalRecords);
  const [deleteParkingType, deleteResponse] = useDeleteParkingTypeMutation();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [vendorId, setVendorId] = useState<number>();
  const [open, setOpen] = useState(false);
  const filteredUsers = parkingManagementData;
  const isUserNotFound = filteredUsers.length === 0;

  const getParkingTypeDataAsync = async (rowPerPages, pages, orders, typeNames = '') => {
    await getParkingTypeData({
      token: token.token,
      payload: { offset: rowPerPages, pageNumber: pages, sortOrder: orders, typeName: typeNames },
    });
  };

  useEffect(() => {
    if (parkingTypeData) {
      setParkingManagementData(parkingTypeData);
    }
  }, [parkingTypeData]);

  useEffect(() => {
    if (token) {
      getParkingTypeDataAsync(rowsPerPage, page, order);
    }
    setFilterName('')
  }, []);

  useEffect(() => {
    if (parkingTypeResponse.isSuccess) {
      dispatch(setParkingType(parkingTypeResponse.data));
    }
    if (parkingTypeResponse.isError) {
      let errorData: any = parkingTypeResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [parkingTypeResponse.isSuccess, parkingTypeResponse.isError]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getParkingTypeDataAsync(rowsPerPage, newPage, order);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getParkingTypeDataAsync(event.target.value, 0, order);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    getParkingTypeDataAsync(rowsPerPage, page, order, event.target.value);
  };

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getParkingTypeDataAsync(rowsPerPage, page, order, '');
    }
    if (deleteResponse.isError) {
      let errorData: any = deleteResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [deleteResponse.isSuccess, deleteResponse.isError]);

  const handleDelete = () => {
    setOpen(false);
    deleteParkingType({
      payload: { id: vendorId },
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="service Overview">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Service Type
          </Typography>
          <Button
            style={{ color: 'white', backgroundColor: '#E23744' }}
            variant="contained"
            onClick={() => {
              navigate('/dashboard/add-or-update-servivce', { state: { editMode: false } });
            }}
            startIcon={<Iconify icon="eva:plus-fill" />}
            size="large"
          >
            Add
          </Button>
        </Stack>
        <Card>
          <BookingListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            placeholder={'Search By Service Categories'}
          />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={parkingManagementData}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const { id, status, typeName, discountType, discountTypeName, discountOffer, imageUrl } = row;
                      const isItemSelected = selected.indexOf(typeName) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Avatar alt="Remy Sharp" src={imageUrl} />
                          </TableCell>
                          <TableCell
                            align="left"
                            onClick={() => {
                              navigate('/dashboard/add-or-update-servivce', {
                                state: { editMode: true, editData: row },
                              });
                            }}
                            style={{ cursor: 'pointer', color: 'blue' }}
                          >
                            <Typography fontWeight="bold" variant="subtitle2">
                              {typeName}
                            </Typography>
                          </TableCell>
                          <TableCell align="justify">
                            <Typography fontWeight="normal" variant="subtitle2">
                              {discountType !== 'DTND'
                                ? discountType === 'DTPRCNT'
                                  ? `${discountOffer}%`
                                  : `₹${discountOffer}`
                                : discountTypeName}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center">
                              <Switch
                                checked={status}
                                onClick={() => {
                                  setVendorId(id);
                                  handleOpen();
                                }}
                              />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={parkingTypeTotalRecord || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {open && (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                Are you sure?
              </Typography>
              <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                <Button
                  variant="contained"
                  onClick={cancelDelete}
                  sx={{ margin: '10px' }}
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                >
                  No
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDelete}
                  sx={{ margin: '10px' }}
                  style={{ color: 'white', backgroundColor: '#E23744' }}
                >
                  Yes
                </Button>
              </Stack>
            </Box>
          </Modal>
        )}
        {parkingTypeResponse.isLoading || deleteResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
